import { type ReactNode } from 'react';
import clsx from 'clsx';

type Padding = 'none' | 'sm' | 'md' | 'lg';

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: Padding;
  /** Adds the subtle gradient border accent (used for the live preview panel). */
  accent?: boolean;
}

const padClass: Record<Padding, string> = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
};

export function Card({ children, className, padding = 'md', accent = false }: CardProps) {
  return (
    <div
      className={clsx(
        'bg-zinc-900 border border-zinc-800 rounded-xl relative',
        padClass[padding],
        accent && 'gradient-border',
        className,
      )}
    >
      {children}
    </div>
  );
}
